<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <div>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/cadastro-linha"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <LinhasFormulario @send="criar" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Linha de Produto criada com sucesso"
      @close="goToLinhas"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { criarLinha } from "@/services/linhas";
import LinhasFormulario from "@/components/linhas/LinhasFormulario.vue";
export default {
  name: "EmpresaParceiraCriar",
  components: { LinhasFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Linha de Produtos",
        disabled: false,
        to: "/cadastro-linha",
      },
      {
        text: "Criar Linha de Produtos",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
  }),
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  methods: {
    async criar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await criarLinha(event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    goToLinhas() {
      this.sucess = false;
      this.$router.push({ name: "LinhasDeProdutos" });
    },
  },
};
</script>

<style></style>
